import { render, staticRenderFns } from "./AppProgramaExpositores.vue?vue&type=template&id=6e65243e&"
import script from "./AppProgramaExpositores.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaExpositores.vue?vue&type=script&lang=ts&"
import style0 from "./AppProgramaExpositores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports